// src/components/trackinginfo/components/TrackingInfoRepSelector.jsx
// ============================================================================
// BLOCK TI.REPSEL.0 — Rep selector for TrackingInfo (values = repNo)
// ============================================================================
import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import fetchTrackingReps from '../api/trackingInfoRepsApi.js';

function TrackingInfoRepSelector({ selectedRepNo, onChange }) {
  const [options, setOptions] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await fetchTrackingReps({ company: 'tzi' });
        const list = Array.isArray(res?.data) ? res.data : [];
        if (alive) {
          setOptions(list);
          setLoaded(true);
        }
      } catch {
        if (alive) {
          setOptions([]);
          setLoaded(true);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return (
    <FormControl size="small" sx={{ minWidth: 240 }}>
      <InputLabel id="trackinginfo-rep-label">Rep</InputLabel>
      <Select
        labelId="trackinginfo-rep-label"
        label="Rep"
        value={selectedRepNo}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">
          <em>All reps</em>
        </MenuItem>

        {loaded &&
          options.map((r) => (
            <MenuItem key={r.no} value={r.no}>
              {r.name} ({r.no})
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

TrackingInfoRepSelector.propTypes = {
  selectedRepNo: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(TrackingInfoRepSelector);
